import {FieldTypeEnum} from "../../../Fields/Core/FBFieldBase.options";
import {SingleValueRetriever} from "../SingleValueRetriever";
import {MultipleValueRetriever} from "../MultipleValueRetriever";
import {NoneValueRetriever} from "../NoneValueRetriever";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {NumericValueRetriever} from "FormBuilder/Core/ValueRetriever/NumericValueRetriever";
import {CheckboxValueRetriever} from "FormBuilder/Core/ValueRetriever/CheckboxValueRetriever";


export class ValueRetrieverFactory {
    public static GetValueRetriever(field:FBFieldBaseModel){
        switch (field.Options.Type) {
            case FieldTypeEnum.Text:
            case FieldTypeEnum.TextArea:
            case FieldTypeEnum.Hidden:
            case FieldTypeEnum.Masked:
                return new SingleValueRetriever(field);
            case FieldTypeEnum.Radio:
            case FieldTypeEnum.DropDown:
            case FieldTypeEnum.Checkbox:
            case FieldTypeEnum.ImagePicker:
            case FieldTypeEnum.ButtonSelection:
                return new MultipleValueRetriever(field);
            case FieldTypeEnum.Datepicker:
            case FieldTypeEnum.Slider:
                return new NumericValueRetriever(field);
            case FieldTypeEnum.Switch:
                return new CheckboxValueRetriever(field);


        }

        return new NoneValueRetriever(field);
    }
}